import React, { /* useEffect, */ useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Heading } from '@front/gatsby-ui';
import Slider from 'react-slick';
import theme from '@front/ds/themes/assignmentcore.com';
import 'Static/slick.css';

// import useOnScreen from '@front/hooks/useOnScreen';
// import useApi from '@front/hooks/useApi';
// import { api } from '@front/gatsby-utils/api';
import { testimonialsDefault } from 'Constants/responses';

import ArrowLeft from 'Img/pic_slider-arrow--left.inline.svg';
import ArrowRight from 'Img/pic_slider-arrow--right.inline.svg';
import bg from 'Img/pic_testimonials--red.svg';
import AdRow, { AdItem } from 'Components/adrow';
import TestimonialCard from './card';

const sliderOptions = {
  autoplaySpeed: 2000,
  adaptiveHeight: false,
  dots: false,
  draggable: true,
  infinite: false,
  speed: 400,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: theme.breakpoints.sm,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: theme.breakpoints.md,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const ArrowWrapper = ({ sx, ...rest }) => (
  <Box
    tabIndex={0}
    onTouchStart={e => e.currentTarget.classList.add('touched')}
    onTouchEnd={e => e.currentTarget.classList.remove('touched')}
    sx={{
      '&.touched': {
        path: {
          fill: 'primary',
        },
      },
      cursor: 'pointer',
      outline: 'none',
      '&.slick-disabled': {
        cursor: 'default',
      },

      '@media (hover: hover)': {
        '&:hover': {
          '&.slick-disabled': {
            path: {
              fill: 'basic.5',
            },
          },
          path: {
            fill: 'primary',
          },
        },
      },

      ...sx,
    }}
    {...rest}
  />
);

export const PrevArrow = ({ sx, ...rest }) => (
  <ArrowWrapper
    as={ArrowLeft}
    mr={3}
    sx={sx}
    {...rest}
  />
);

export const NextArrow = ({ sx, ...rest }) => (
  <ArrowWrapper
    as={ArrowRight}
    sx={sx}
    {...rest}
  />
);

const Testimonials = ({ title, defaultData: data, ...rest }) => {
  const ref = useRef({ current: null });

  // const isIntersecting = useOnScreen(ref, { init: false, once: true });
  // const {
  //   request,
  //   data = defaultData,
  // } = useApi(api.testimonials, {}, false);
  //
  // /* eslint-disable react-hooks/exhaustive-deps */
  // useEffect(() => {
  //   if (isIntersecting) {
  //     request();
  //   }
  // }, [isIntersecting]);
  // /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <Box
      bg="#FEF6F7"
      py={{ _: 4, md: '96px' }}
    >
      <Flex
        flexDirection={{ _: 'column', lg: 'row' }}
        sx={{
          maxWidth: '1920px',
          margin: '0 auto',
          alignItems: 'center',

          '.slick-arrow': {
            position: 'absolute',
            bottom: ['-32px', null, null, null, '25%'],
          },

          '.slick-prev': {
            left: [
              'calc(50% - 100px)',
              null,
              'calc(50% - 126px)',
              null,
              'calc(-60px - 126px - 24px)',
              'calc(-120px - 126px - 24px)',
            ],
          },

          '.slick-next': {
            left: [
              'calc(50% + 16px)',
              null,
              'calc(50% + 68px - 24px)',
              null,
              'calc(-60px - 68px)',
              'calc(-120px - 68px)',
            ],
          },
        }}
      >
        <AdRow
          sx={{
            alignItems: 'center',
            maxWidth: '840px',
            width: '100%',
          }}
        >
          <AdItem
            display={{ _: 'none', lg: 'block' }}
            pr={{ md: 3 }}
          >
            <img
              src={bg}
              alt="Testimonials"
              loading="lazy"
              width={317}
              height={394}
            />
          </AdItem>
          <AdItem
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Heading
              as="h2"
              variant="h2"
              textAlign="center"
            >
              {title}
            </Heading>
          </AdItem>
        </AdRow>
        <Box
          py={4}
          px={3}
          sx={{
            width: '100%',
          }}
          {...rest}
        >
          <Slider
            ref={ref}
            prevArrow={<PrevArrow />}
            nextArrow={<NextArrow />}
            {...sliderOptions}
          >
            {data.map(testimonial => (
              <TestimonialCard
                key={testimonial.order.id}
                {...testimonial}
              />
            ))}
          </Slider>
        </Box>
      </Flex>
    </Box>
  );
};

Testimonials.propTypes = {
  title: PropTypes.node,
  defaultData: PropTypes.arrayOf(PropTypes.shape({})),
};

Testimonials.defaultProps = {
  title: 'What customers say about us',
  defaultData: testimonialsDefault,
};

export default Testimonials;
